import React from "react";
import { PullQuoteBase, Quote, Attribution } from "./pull-quote.styled";
import { PullQuoteSliceFragment } from "../../types/graphql";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IPullQuoteProps = Slice<
  SharedSliceType,
  PullQuoteSliceFragment["primary"]
> & { type: SharedSliceType };

const PullQuote = ({
  slice,
  context,
}: SliceComponentProps<IPullQuoteProps, IPageContext>) => {
  const pullQuote = slice.primary;

  return (
    (pullQuote && (
      <PullQuoteBase>
        {pullQuote.quote && <Quote>{pullQuote.quote}</Quote>}
        {pullQuote?.attribution_name && pullQuote.attribution_title && (
          <Attribution>
            {pullQuote?.attribution_name}
            {pullQuote.attribution_title && ","}
          </Attribution>
        )}
        {pullQuote?.attribution_title && (
          <Attribution>{pullQuote?.attribution_title}</Attribution>
        )}
      </PullQuoteBase>
    )) || <></>
  );
};

export default PullQuote;
